import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CustomerService } from 'src/app/services/customer.service';


@Component({
	selector: 'imprint',
	templateUrl: './imprint.component.html',
	styleUrls: [ './single-page.css' ],
})
export class ImprintComponent {


	bLoading = true;
	bError = false;
	legalHtml: SafeHtml = "";
	

	constructor(
		private customerService: CustomerService,
		private domSanitizer: DomSanitizer
	) {}

	
	ngOnInit(): void {
		
		this.customerService.loadLegalInformation().subscribe( data => {

			this.bLoading = false;
			this.bError = !data;
			if( data ) {
				this.legalHtml = this.domSanitizer.bypassSecurityTrustHtml( data.imprint );	
			}

		} );

	}
	
}
